(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["ppf-build-a-box"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const styleDefinitions = {
      '3bags': {
        label: '3 Bags',
        cartName: { dog: 'Dog 3 Bags', cat: 'Cat 3 Bags' },
        slots: [
          { key: 'full-1', bucket: 'full', label: 'Bag 1' },
          { key: 'full-2', bucket: 'full', label: 'Bag 2' },
          { key: 'full-3', bucket: 'full', label: 'Bag 3' },
        ],
      },
      '2plus2': {
        label: '2+2',
        cartName: { dog: 'Dog 2+2', cat: 'Cat 2+2' },
        slots: [
          { key: 'full-1', bucket: 'full', label: 'Full-size 1' },
          { key: 'full-2', bucket: 'full', label: 'Full-size 2' },
          { key: 'trial-1', bucket: 'trial', label: 'Trial 1' },
          { key: 'trial-2', bucket: 'trial', label: 'Trial 2' },
        ],
      },
    };

    const normalize = (value) => (value || '').toString().trim().toLowerCase();

    const formatCents = (cents) =>
      new Intl.NumberFormat('en-US', {
        style: 'currency',
        currency: window.Shopify?.currency?.active || 'USD',
      }).format((Number(cents) || 0) / 100);

    const parseProducts = (root) => {
      const dataNode = root.querySelector('[data-ppf-build-a-box-products]');
      if (!dataNode) return null;

      try {
        return JSON.parse(dataNode.textContent);
      } catch (error) {
        console.error('Build-a-Box product data could not be parsed.', error);
        return null;
      }
    };

    const productsFor = (catalog, species, bucket) =>
      (catalog?.[species]?.[bucket] || []).filter((product) => product?.variantId);

    const availableProductsFor = (catalog, species, bucket, goal) =>
      productsFor(catalog, species, bucket)
        .filter((product) => product.available)
        .map((product, index) => ({ product, index }))
        .sort((a, b) => {
          if (!goal) return a.index - b.index;
          const aMatches = (a.product.goals || []).map(normalize).includes(goal);
          const bMatches = (b.product.goals || []).map(normalize).includes(goal);
          if (aMatches === bMatches) return a.index - b.index;
          return aMatches ? -1 : 1;
        })
        .map(({ product }) => product);

    const styleIsEnabled = (catalog, species, style) => {
      const definition = styleDefinitions[style];
      if (!definition) return false;

      return definition.slots.every(
        (slot) => availableProductsFor(catalog, species, slot.bucket, '').length > 0
      );
    };

    const findProduct = (catalog, species, bucket, protein) =>
      productsFor(catalog, species, bucket).find(
        (product) => normalize(product.protein) === protein
      );

    const buildDefaultSelections = (catalog, species, style, goal, preselect) => {
      const definition = styleDefinitions[style];
      const selections = [];
      let note = '';
      const preselectedByBucket = {};

      if (preselect) {
        ['full', 'trial'].forEach((bucket) => {
          const candidate = findProduct(catalog, species, bucket, preselect);
          if (candidate?.available) {
            preselectedByBucket[bucket] = candidate;
          } else if (candidate) {
            note = 'Unavailable selections were replaced with available same-species products.';
          }
        });
      }

      definition.slots.forEach((slot, index) => {
        const available = availableProductsFor(catalog, species, slot.bucket, goal);
        if (available.length === 0) return;

        if (
          preselectedByBucket[slot.bucket] &&
          !selections.some((p) => p === preselectedByBucket[slot.bucket])
        ) {
          selections.push(preselectedByBucket[slot.bucket]);
          return;
        }

        const bucketSlotIndex =
          definition.slots
            .slice(0, index + 1)
            .filter((candidateSlot) => candidateSlot.bucket === slot.bucket).length - 1;
        selections.push(available[bucketSlotIndex % available.length]);
      });

      return { selections, note };
    };

    const renderProductCard = (product) => {
      const image = product.image
        ? `<img src="${product.image}" alt="${product.imageAlt || product.title}" width="360" height="360" loading="lazy">`
        : '';
      const status = product.available ? product.priceMoney : 'Sold out';

      return `
        <a class="ppf-build-a-box-product" href="${product.url}" aria-disabled="${product.available ? 'false' : 'true'}">
          <span class="ppf-build-a-box-product__media">${image}</span>
          <span class="ppf-build-a-box-product__copy">
            <span class="ppf-build-a-box-product__title">${product.title}</span>
            <span class="ppf-build-a-box-product__meta">
              <span>${product.feedingSize || ''}</span>
              <span>${product.protein || ''}</span>
              <span class="ppf-build-a-box-product__status">${status}</span>
            </span>
          </span>
        </a>
      `;
    };

    const renderOption = (product, selectedVariantId) => {
      const soldOut = product.available ? '' : ' - Sold out';
      return `
        <option value="${product.variantId}" ${product.variantId === selectedVariantId ? 'selected' : ''} ${product.available ? '' : 'disabled'}>
          ${product.title} - ${product.priceMoney}${soldOut}
        </option>
      `;
    };

    const initBuildABox = (root = document) => {
      root.querySelectorAll('[data-ppf-build-a-box]').forEach((section) => {
        if (section.dataset.ppfBuildABoxReady === 'true') return;
        section.dataset.ppfBuildABoxReady = 'true';

        const catalog = parseProducts(section);
        if (!catalog) return;

        const params = new URLSearchParams(window.location.search);
        const species = normalize(params.get('species'));
        const goal = normalize(params.get('goal'));
        const preselect = normalize(params.get('preselect'));
        const gate = section.querySelector('[data-ppf-build-a-box-gate]');
        const app = section.querySelector('[data-ppf-build-a-box-app]');

        if (!['dog', 'cat'].includes(species)) {
          gate.hidden = false;
          app.hidden = true;
          return;
        }

        gate.hidden = true;
        app.hidden = false;

        const threshold = Number(section.dataset.freeShippingThreshold || 8900);
        const state = {
          species,
          goal,
          style: styleIsEnabled(catalog, species, params.get('style'))
            ? params.get('style')
            : '3bags',
          selections: [],
          note: '',
        };

        if (!styleIsEnabled(catalog, species, state.style)) {
          state.style = styleIsEnabled(catalog, species, '2plus2') ? '2plus2' : '3bags';
        }

        const slotsNode = section.querySelector('[data-ppf-slots]');
        const gridNode = section.querySelector('[data-ppf-product-grid]');
        const noteNode = section.querySelector('[data-ppf-selection-note]');
        const subtotalNode = section.querySelector('[data-ppf-subtotal]');
        const freeShippingCopy = section.querySelector('[data-ppf-free-shipping-copy]');
        const freeShippingBar = section.querySelector('[data-ppf-free-shipping-bar]');
        const addButton = section.querySelector('[data-ppf-build-a-box-add]');
        const statusNode = section.querySelector('[data-ppf-build-a-box-status]');
        const titleNode = section.querySelector('[data-ppf-box-title]');
        const kickerNode = section.querySelector('[data-ppf-box-kicker]');

        const setSelectionsForStyle = () => {
          const defaults = buildDefaultSelections(catalog, species, state.style, goal, preselect);
          state.selections = defaults.selections;
          state.note = defaults.note;
        };

        const selectedProducts = () => state.selections.filter(Boolean);

        const subtotal = () =>
          selectedProducts().reduce((total, product) => total + (Number(product.price) || 0), 0);

        const updateSpeciesLinks = () => {
          section.querySelectorAll('[data-ppf-species-link]').forEach((link) => {
            const linkSpecies = link.dataset.ppfSpeciesLink;
            if (linkSpecies === species) {
              link.setAttribute('aria-current', 'page');
            } else {
              link.removeAttribute('aria-current');
            }
          });
        };

        const updateStyleButtons = () => {
          section.querySelectorAll('[data-ppf-style]').forEach((button) => {
            const style = button.dataset.ppfStyle;
            const enabled = styleIsEnabled(catalog, species, style);
            button.disabled = !enabled;
            button.setAttribute('aria-pressed', style === state.style ? 'true' : 'false');
          });
        };

        const updateSummary = () => {
          const definition = styleDefinitions[state.style];
          const boxName = definition.cartName[species];
          titleNode.textContent = boxName;
          kickerNode.textContent = `${species === 'dog' ? 'Dog' : 'Cat'} only`;
          subtotalNode.textContent = formatCents(subtotal());

          const remaining = Math.max(threshold - subtotal(), 0);
          if (remaining > 0) {
            freeShippingCopy.textContent = `${formatCents(remaining)} away from free shipping.`;
          } else {
            freeShippingCopy.textContent = 'This box reaches the free shipping threshold.';
          }
          freeShippingBar.style.width = `${Math.min((subtotal() / threshold) * 100, 100)}%`;

          addButton.textContent = `Add ${boxName}`;
          addButton.disabled =
            selectedProducts().length !== definition.slots.length ||
            selectedProducts().some((product) => !product.available);
        };

        const renderSlots = () => {
          const definition = styleDefinitions[state.style];
          slotsNode.innerHTML = definition.slots
            .map((slot, index) => {
              const products = productsFor(catalog, species, slot.bucket);
              const selected = state.selections[index];
              return `
                <div class="ppf-build-a-box-slot">
                  <label for="${section.id}-${slot.key}">${slot.label}</label>
                  <select id="${section.id}-${slot.key}" data-ppf-slot-index="${index}" data-ppf-slot-bucket="${slot.bucket}">
                    ${products.map((product) => renderOption(product, selected?.variantId)).join('')}
                  </select>
                  <span class="ppf-build-a-box-slot__price">${selected?.priceMoney || ''}</span>
                </div>
              `;
            })
            .join('');
        };

        const renderProducts = () => {
          const fullProducts = productsFor(catalog, species, 'full');
          const trialProducts = productsFor(catalog, species, 'trial');
          gridNode.innerHTML = [...fullProducts, ...trialProducts].map(renderProductCard).join('');
        };

        const renderNote = () => {
          if (!state.note) {
            noteNode.hidden = true;
            noteNode.textContent = '';
            return;
          }

          noteNode.hidden = false;
          noteNode.textContent = state.note;
        };

        const render = () => {
          updateSpeciesLinks();
          updateStyleButtons();
          renderSlots();
          renderProducts();
          renderNote();
          updateSummary();
        };

        section.addEventListener('click', (event) => {
          const styleButton = event.target.closest('[data-ppf-style]');
          if (!styleButton || styleButton.disabled) return;
          state.style = styleButton.dataset.ppfStyle;
          state.note = '';
          setSelectionsForStyle();
          if (statusNode) statusNode.textContent = '';
          render();
        });

        section.addEventListener('change', (event) => {
          const select = event.target.closest('[data-ppf-slot-index]');
          if (!select) return;
          const index = Number(select.dataset.ppfSlotIndex);
          const bucket = select.dataset.ppfSlotBucket;
          const product = productsFor(catalog, species, bucket).find(
            (candidate) => String(candidate.variantId) === String(select.value)
          );
          if (product?.available) {
            state.selections[index] = product;
            state.note = '';
            if (statusNode) statusNode.textContent = '';
            render();
          }
        });

        addButton.addEventListener('click', async () => {
          const definition = styleDefinitions[state.style];
          const boxName = definition.cartName[species];
          const selections = selectedProducts();
          if (
            selections.length !== definition.slots.length ||
            selections.some((product) => !product.available)
          ) {
            if (statusNode)
              statusNode.textContent = 'Please choose available products for every slot.';
            return;
          }

          const properties = {
            'Build a Box': boxName,
            _ppf_box_species: species,
            _ppf_box_style: state.style,
            _ppf_box_source: 'build-a-box',
          };
          if (goal) properties._ppf_box_goal = goal;

          const grouped = selections.reduce((items, product) => {
            const key = String(product.variantId);
            if (!items[key]) {
              items[key] = { id: Number(product.variantId), quantity: 0, properties };
            }
            items[key].quantity += 1;
            return items;
          }, {});

          addButton.disabled = true;
          addButton.setAttribute('aria-busy', 'true');
          const originalText = addButton.textContent;
          addButton.textContent = 'Adding...';
          if (statusNode) statusNode.textContent = '';

          const sectionsToBundle = ['variant-added'];
          document.documentElement.dispatchEvent(
            new CustomEvent('cart:prepare-bundled-sections', {
              bubbles: true,
              detail: { sections: sectionsToBundle },
            })
          );

          try {
            const response = await fetch(`${Shopify.routes.root}cart/add.js`, {
              method: 'POST',
              headers: {
                'Content-Type': 'application/json',
                'X-Requested-With': 'XMLHttpRequest',
              },
              body: JSON.stringify({
                items: Object.values(grouped),
                sections: sectionsToBundle.join(','),
                sections_url: `${Shopify.routes.root}pages/build-a-box`,
              }),
            });
            const responseJson = await response.json();

            if (!response.ok) {
              throw new Error(responseJson.description || 'Unable to add this box.');
            }

            if (
              window.themeVariables?.settings?.cartType === 'page' ||
              window.themeVariables?.settings?.pageType === 'cart'
            ) {
              window.location.href = `${Shopify.routes.root}cart`;
              return;
            }

            const cartContent = await (await fetch(`${Shopify.routes.root}cart.js`)).json();
            cartContent.sections = responseJson.sections || {};

            addButton.dispatchEvent(
              new CustomEvent('variant:add', {
                bubbles: true,
                detail: {
                  items: responseJson.items || [],
                  cart: cartContent,
                },
              })
            );
            document.documentElement.dispatchEvent(
              new CustomEvent('cart:change', {
                bubbles: true,
                detail: {
                  baseEvent: 'variant:add',
                  cart: cartContent,
                },
              })
            );

            if (statusNode) statusNode.textContent = `${boxName} added.`;
          } catch (error) {
            if (statusNode) statusNode.textContent = error.message;
          } finally {
            addButton.removeAttribute('aria-busy');
            addButton.textContent = originalText;
            updateSummary();
          }
        });

        setSelectionsForStyle();
        render();
      });
    };

    initBuildABox();
    document.addEventListener('shopify:section:load', (event) => initBuildABox(event.target));
  })();

  } catch(e) { console.error(e); }
})();
})();
